import { Button, Typography, Dialog, TextField, IconButton, Box, DialogContent, DialogActions, FormHelperText, DialogTitle, Alert } from "@mui/material";
import { CustomErrorLogger } from "../utils/CustomErrorLogger";
import { useTranslation } from "react-i18next";
import { useState, useCallback } from "react";
import Iconify from "../components/Iconify";
import { LoadingButton } from "@mui/lab";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from "axios";
import '../css/forgotPassword.css';

const ForgotPassword = ({ openForgotPass, setOpenForgotPass }) => {

  const { t } = useTranslation();

  const [msg, setMsg] = useState(null);
  const [buttonLoading, setButtonLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().email(t('emailFormatRequired')).required(t('emailRequied')),
    }),
    onSubmit: async (values) => {
      setButtonLoading(true);
      setMsg(null);

      try {
        const { status, data } = await axios.post('forgot-password/sendEmailForgotPassword', { email: values.email });
        if (status === 200 || status === 201 || status === 202 || status === 204) {
          setMsg(data);
        }
      } catch (err) {
        setMsg(err.message);
        console.error('Error send email forgot password:', err);
        CustomErrorLogger(err, 'error send email forgot password in ForgotPassword');
      } finally {
        setButtonLoading(false);
      }
    },
  });

  const handleClose = useCallback(() => setOpenForgotPass(false), [setOpenForgotPass]);

  const { handleSubmit, values, handleChange, handleBlur, touched, errors } = formik;

  return (
    <Dialog open={openForgotPass} fullWidth>

      <DialogTitle className="FG_dialog_title_box">
        <Typography className='FG_dialog_title'>{t('enterYourEmail')}</Typography>
        <IconButton onClick={handleClose}>
          <Iconify icon={"material-symbols:close"} className='FG_close_icon' />
        </IconButton>
      </DialogTitle>

      <form onSubmit={handleSubmit}>
        <DialogContent className='FG_dialog_content'>
          {msg && <Alert key={msg} severity="info">{msg}</Alert>}
          <Box width={'100%'}>
            <FormHelperText id="outlined-weight-helper-text" className="FG_input_title">{t('adressEmail')}</FormHelperText>
            <TextField
              id="ForgotPassEmail"
              name="email"
              type="email"
              fullWidth
              required
              className="customTextField"
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.email && Boolean(errors.email)}
              helperText={touched.email && errors.email}
            />
          </Box>
        </DialogContent>
        <DialogActions className='FG_dialog_actions'>
          <Button className='FG_button_annuler' onClick={handleClose}>{t('Annuler')}</Button>
          <LoadingButton loading={buttonLoading} className='FG_button_valider' type="submit" variant="contained">{t('send')}</LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default ForgotPassword;